import React, { useContext } from 'react';
import { DropDown } from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function Quantity({ handleChange, selectedQuantity }) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
  } = ProductPageState;

  const {
    activeProduct,
  } = collectionData;

  if (activeProduct.maxPurchaseQty <= 1) {
    return null;
  }

  const buildOptions = () => {
    const options = [];
    for (let i = 1; i <= activeProduct.maxPurchaseQty; i += 1) {
      options.push({
        label: i.toString(),
        value: i.toString(),
      });
    }
    return options;
  };

  const updateQuantity = (e) => {
    handleChange(e.target.value);
  };

  return (
    <div
      className="product-quantity-dropdown-container"
      data-product-brand={activeProduct.brand}
      data-testid="product-quantity-dropdown-container"
    >
      <DropDown
        id="product-quantity-dropdown"
        label="Qty"
        options={buildOptions()}
        brand={activeProduct.brand}
        onChange={updateQuantity}
        value={selectedQuantity}
      />
    </div>
  );
}
